import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Box, Text } from 'core/components';
const LabelValue = ({
  label,
  value,
  valueTextProps,
  ...rest
}) => /*#__PURE__*/React.createElement(Box, _extends({
  mb: 1
}, rest), /*#__PURE__*/React.createElement(Text, {
  fontWeight: "bold"
}, label), ": ", value && /*#__PURE__*/React.createElement(Text, valueTextProps, value));
LabelValue.defaultProps = {
  valueTextProps: {}
};
export default LabelValue;